// extracted by mini-css-extract-plugin
module.exports = {"formcard":"FormCard_formcard__3JdmF"};